import { applicationStates, dashboardButtonLayouts } from '/business/shared/util/Statics';

type DashboardApplication = {
  optionalPaymentIsLocked?: boolean;
};

type DashboardTab = {
  state: string;
  i18nKey?: string;
  ctaLookupState?: string;
  rule?: (application: DashboardApplication) => boolean;
};

function getDashboardTabsFromTabGroup(state: string): DashboardTab[] {
  if (state === applicationStates.SUBMITTED) {
    /*
     Just return a { state } by default to load applications for that state within a tab group
     But you may also return:
     {
      state,
      i18nKey (defaults to state if not set), used to load displayable text
      ctaLookupState, (defaults to state if not set), allows you to look up different values.
       - Used by getDashboardTabCTAPermission() 'tableState' variable
      rule: (application) => {}, return TRUE if we want to include values or not
     */
    return [
      { state: applicationStates.OFFERDECLARED },
      // Reviewed is duplicated so that we have 2 different tables
      // one for optional-payments functionality, for applications that have been set as user
      // changing their mind and no longer wanting to pay
      // and thus awaiting for app. support to 'unlock the payment'
      {
        state: applicationStates.REVIEWED,
        i18nKey: 'paymentLocked',
        ctaLookupState: dashboardButtonLayouts.CTA_SHOW_OVERRIDE_PAY_BTN,
        rule: (application) => {
          return !!application.optionalPaymentIsLocked;
        },
      },
      // This reviewed state is for standard applications that are reviewed (and for mandatory castrol builds)
      {
        state: applicationStates.REVIEWED,
        rule: (application) => {
          return !application.optionalPaymentIsLocked;
        },
      },
      { state: applicationStates.SUBMITTED },
    ];
  }
  return [{ state }];
}

export default getDashboardTabsFromTabGroup;
